import { useQueryClient } from 'react-query';

import { useDelete } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useDeleteRecruitmentStatusDefinition = () => {
  const queryClient = useQueryClient();
  return useDelete({
    url: ApiRoutesEnum.recruitmentUpdateStatusDefinition,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.recruitmentStatuses]);
    },
  });
};
